import backboneSource from 'backbone-source';
import jqueryProvide from './jquery-provide.js';
import underscoreProvide from './underscore-provide.js';

if (!window.Backbone && !globalThis.Backbone) {
  // Execute the legacy bundle outside the webpack module wrapper.
  // The file expects top-level this to resolve to the global object.
  new Function('$', '_', backboneSource)(jqueryProvide, underscoreProvide);
}

const resolvedBackbone = window.Backbone || globalThis.Backbone;

if (!resolvedBackbone || !resolvedBackbone.Model || typeof resolvedBackbone.Model.extend !== 'function') {
  throw new Error('Backbone global was not initialized');
}

window.Backbone = resolvedBackbone;

export default resolvedBackbone;
